var nurseslounge_lounge_followers = {
    init:function($params){
        nurseslounge_lounge_followers.lounge_followers_load($params);
        nurseslounge_lounge_followers.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_lounge_followers.task_list_container(function($container){
            $params = $.extend({}, $params, {only:'owners'});
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
    },
    lounge_followers_load:function($params){
        var $loungeFollowersLeft = $("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-left");
        var $form = $loungeFollowersLeft.find('form:first');
        var $name = $loungeFollowersLeft.find("input[name='name']");
        var $reset = $loungeFollowersLeft.find('.reset');
        $form.unbind().submit(function($e){
            $e.preventDefault();
            nurseslounge_lounge_followers.lounge_followers_search($params);
        });
        nurseslounge_lounge_followers.lounge_followers_autocomplete(
            $name,
            $params,
            "/lounge/followers/autocomplete",
            function($keyword){
                nurseslounge_lounge_followers.lounge_followers_search($params);
            }
        );
        $reset.unbind().click(function(){
            $form[0].reset();
            nurseslounge_lounge_followers.lounges_home_search($params);
        });
        nurseslounge_lounge_followers.lounge_followers_search($params);
    },
    lounge_followers_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    lounge_followers_search:function($params){
        var $loungeFollowersLeft = $("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-left");
        var $name = $loungeFollowersLeft.find("input[name='name']");
        var $followersList = $loungeFollowersLeft.find(".followers-list:first");
        var $followersListPreview = nurseslounge_lounge_followers.followers_preview();
        var $resultInfo = $loungeFollowersLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $loungeFollowersLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $params = $.extend({},$params,{
            name:$name.val(),
        });
        $resultInfo.addClass('nurseslounge-lounge-followers-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-lounge-followers-preload').html($paginationNavPreview);
        $followersList.html($followersListPreview).promise().done(function(){
            nurseslounge_lounge_followers.followers_pagination($params);
        });
    },
    followers_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3 nurseslounge-lounge-followers-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="nurseslounge-lounge-followers-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="nurseslounge-lounge-followers-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center nurseslounge-lounge-followers-preload">' +
                '            <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    followers_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $loungeFollowersLeft = $("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-left");
        var $followersList = $loungeFollowersLeft.find(".followers-list:first");
        var $paginationNav = $loungeFollowersLeft.find('.pagination-nav');
        var $previewHeight = $loungeFollowersLeft.find('.followers-list .preview:first').innerHeight();
        var $followersHeight = $followersList.innerHeight();
        var $pageSize = Math.round(($followersHeight/$previewHeight));
        var $resultInfo = $loungeFollowersLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('followers_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource: window.location.protocol +'//'+ window.location.hostname + "/lounge/followers/get",
            locator: 'data.followers',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $followersList.html(nurseslounge_lounge_followers.followers_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($followersList.length > 0 && $followersList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$followersList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-lounge-followers-preload');
                $resultInfo.removeClass('nurseslounge-lounge-followers-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Degrees</span>');
                var $chtml = nurseslounge_lounge_followers.followers_item_html($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $followersList.html('').html($chtml).promise().done(function () {
                        nurseslounge_lounge_followers.followers_list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('lounge_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_lounge_followers.followers_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    followers_item_html:function($followers){
        var $chtml = '';
        $.each($followers, function($i, $v){
            var $img = $v.user.profile_image_root_wall;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="'+$v.user.id+'" data-url="'+$v.user.profile_url+'">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3">' +
                '                    <img src="'+$img+'?resize=80" alt="profile">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="">' +
                $v.user.long_name+
                '                    </h4>' +
                '                    <p class="">' +
                $v.user.profile.profile+
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center ">' +
                '           <div class="col-md-auto text-center text-sm-right align-self-center">'+
                '               <button type="button" class="btn btn-save btnAnimate send-invite">Send Invite</button>'+
                '           </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    followers_list_events:function($saveParams){
        var $loungeFollowersLeft = $("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-left");
        var $followersList = $loungeFollowersLeft.find(".followers-list:first");
        $loungeFollowersLeft.find('.send-invite').unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $item = $that.parents('.item:first');
            var $toUserId = $item.data('id');
            var $params = $.extend({}, $saveParams, {to_user_id:$toUserId, status_id:1});
            nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function(){
                nurseslounge_lounge_followers.init($saveParams);
            });
        });
        $followersList.find('.item').unbind().click(function () {
            var $that = $(this);
            var $profileUrl = $that.data('url');
            window.open($profileUrl, '_blank');
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-right .banners")
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-lounge-followers .nurseslounge-lounge-followers-right");
        cback($container);
    },
};
